import { get } from "lodash";
import log from "loglevel";
import {
  BasicPostDataDeserializerType,
  BasicErrorDeserializerType,
  SuccessType,
  ErrorType,
  AuthSuccessType,
} from "types";
import * as t from "./types";

export const getLoginData = (
  state: any
): t.LoginDataDeserializerType | undefined => {
  if (get(state, "login.response.data")) {
    return state.login.response.data;
  } else {
    return undefined;
  }
};

export const getLoginError = (state: any): ErrorType | undefined => {
  if (get(state, "login.response.error")) {
    return state.login.response.error;
  } else {
    return undefined;
  }
};

export const getResetAuthReducerResponse = (
  state: any,
  responseType: string
): BasicPostDataDeserializerType | BasicErrorDeserializerType => {
  const value = get(state, `resetAuth.response.${responseType}`);
  return value;
};

export const getCreatePasswordNoAuthReducerResponse = (
  state: any,
  responseType: string
): SuccessType => {
  log.info("Getting CreatePasswordNoAuth from Store...");
  const value = get(state, `createPasswordNoAuth.response.${responseType}`);
  return value;
};

export const getCreatePasswordNoAuthReducerError = (state: any): ErrorType => {
  log.info("Getting CreatePasswordNoAuth from Store...");
  const value = get(state, `createPasswordNoAuth.response.error`);
  return value;
};

export const getAuthyRegisterReducerResponse = (
  state: any,
  responseType: string
): SuccessType => {
  log.info("Getting AuthyRegister from Store...");
  const value = get(state, `authyRegister.response.${responseType}`);
  return value;
};

export const getAuthyRegisterReducerError = (state: any): ErrorType => {
  log.info("Getting AuthyRegister Error from Store...");
  const value = get(state, `authyRegister.response.error`);
  return value;
};

export const getAuthyVerifyReducerResponse = (
  state: any,
  responseType: string
): SuccessType => {
  log.info("Getting AuthyVerify from Store...");
  const value = get(state, `authyVerify.response.${responseType}`);
  return value;
};

export const getAuthyVerifyReducerError = (state: any): ErrorType => {
  log.info("Getting AuthyVerify Error from Store...");
  const value = get(state, `authyVerify.response.error`);
  return value;
};

export const getAuthyOtpReducerResponse = (
  state: any,
  responseType: string
): AuthSuccessType => {
  log.info("Getting AuthyOtp from Store...");
  const value = get(state, `authyOtp.response.${responseType}`);
  return value;
};

export const getAuthyOtpReducerError = (state: any): ErrorType => {
  log.info("Getting AuthyOtp Error from Store...");
  const value = get(state, `authyOtp.response.error`);
  return value;
};
